// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorAccountPharmacyCoverageModels {
    static getAttributeTypeMap() {
        return PayorAccountPharmacyCoverageModels.attributeTypeMap;
    }
}
PayorAccountPharmacyCoverageModels.discriminator = undefined;
PayorAccountPharmacyCoverageModels.additionalProperties = false;
PayorAccountPharmacyCoverageModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<PayorAccountPharmacyCoverageModel>"
    },
];
//# sourceMappingURL=payorAccountPharmacyCoverageModels.js.map